import Footer from "../components/footer";
import Navbar from "../components/navbar";
import TermsOfService from "../components/terms";

function Terms(){
    return(
<>
        <Navbar/>

        <TermsOfService />

        <Footer/>
</>            

    );
}   
export default Terms;